/**
 * Role utility functions for authorization checks
 * 
 * NOTE: Lead roles are dynamically loaded from MDM_Roles table on the backend.
 * All roles EXCEPT "BRG.Member" are considered Lead roles.
 * The list below is a reference for frontend UI decisions, but the backend
 * enforces the actual authorization by querying MDM_Roles.
 */

const LEAD_ROLES = [
  'BRG-Lead',
  'BRG.Co-Leader',
  'Community Lead',
  'Co-Community Lead',
  'Executive Champion',
  'HR Support Lead',
  'Adviser',
  'Co-Adviser',
];

/**
 * Check if user has any Lead role
 */
export function isLeadRole(roles: string[] | undefined): boolean {
  return (roles ?? []).some(role => LEAD_ROLES.includes(role));
}

/**
 * Check if user is an admin
 */
export function isAdmin(roles: string[] | undefined): boolean {
  return (roles ?? []).includes('BRG.Admin');
}

/**
 * Check if user has Lead or Admin role
 */
export function isLeaderPlus(roles: string[] | undefined): boolean {
  return isAdmin(roles) || isLeadRole(roles);
}

/**
 * Check if user has Member or higher role
 */
export function isMemberPlus(roles: string[] | undefined): boolean {
  return (
    isAdmin(roles) ||
    isLeadRole(roles) ||
    (roles ?? []).includes('BRG.Member')
  );
}
